<script lang="ts">
  import { Button } from "@/components/ui/button";
  import { Image } from "@/components/ui/image";
  import DropdownMenu from "@/components/ui/menu-dropdown.svelte";
  import { createPortal } from "@/helpers/usePortal";
  import Logo from "@/images/playplex_home.svg";
  import { isUserLoading, user } from "@/stores/user";
  import { quintOut } from "svelte/easing";
  import { slide } from "svelte/transition";
  import i18n from "@/stores/i18n";

  import ProfileMenuDropdown from "@/components/profile/profile-menu-dropdown.svelte";
  import LoginDialog from "./login/login-dialog.svelte";
  import ProfileMenuContent from "./profile/profile-menu-content.svelte";
  import SpecificNavbar from "./specificNavbar.svelte";
  import LanguageSelector from "./language-selector.svelte";

  import CloseIcon from "@/images/Close.svg";
  import MenuIcon from "@/images/menu.svg";
  import { onMount } from "svelte";
  import { localizeUrl } from "@/helpers/localization";

  let showLoginDialog = $state(false);
  interface Props {
    showMobileMenu?: boolean;
  }

  let { showMobileMenu = $bindable(false) }: Props = $props();

  let showSecondNavbar = $state(false);
  let currentRoute = "";
  let currentGame = $state("");

  const numBoosters = 98 - new Date().getHours();

  const handleShowLogin = () => {
    if (!($user || $isUserLoading)) {
      showLoginDialog = true;
    }
  };

  onMount(() => {
    currentRoute = window.location.pathname;

    if (currentRoute.includes("/league-of-legends/")) {
      showSecondNavbar = true;
      currentGame = "lol";
    } else if (currentRoute.includes("/valorant/")) {
      showSecondNavbar = true;
      currentGame = "valorant";
    } else if (currentRoute.includes("/cs2/")) {
      showSecondNavbar = true;
      currentGame = "cs2";
    } else {
      showSecondNavbar = false;
    }
  });

  const t = (key: string) => $i18n.t(key, { ns: "common" });
</script>

<div class="flex w-full flex-col justify-center px-6">
  <div
    color="none"
    class="relative mx-auto mt-4 flex h-[72px] w-full max-w-[1200px] items-center justify-between rounded-t-[8px] border border-dark-gray bg-theme-black p-4">
    <div class="flex items-center gap-2">
      <a href={localizeUrl("/")} class="mx-3">
        <Image src={Logo} alt="Playplex Logo" />
      </a>

      {#key showMobileMenu}
        <ul
          transition:slide={{
            delay: 250,
            duration: 300,
            easing: quintOut,
            axis: "y"
          }}
          class="absolute left-0 top-16 z-50 mt-4 hidden w-full flex-col justify-end gap-y-3 rounded-xl border border-dark-gray bg-theme-black p-4 lg:relative lg:top-0 lg:mt-0 lg:flex lg:w-fit lg:flex-row lg:items-center lg:space-x-2 lg:border-none lg:p-2 lg:text-sm lg:font-medium"
          class:!flex={showMobileMenu}>
          <DropdownMenu
            text={showSecondNavbar
              ? t("navigation.switch_game")
              : t("navigation.select_game")}
            {showSecondNavbar}
            links={[
              {
                href: "/league-of-legends/boosting/",
                label: "League of Legends",
                image: "/images/lol.svg"
              },
              {
                href: "/valorant/boosting/",
                label: "Valorant",
                image: "/images/val.svg"
              },
              {
                href: "/cs2/boosting/",
                label: "Counter-Strike 2",
                image: "/images/cs2.svg"
              }
            ]} />

          <span
            class="inline-flex items-center justify-center rounded-[40px] border border-dark-gray px-3 py-2.5 font-medium text-success-green"
            style="background: linear-gradient(90deg, rgba(4, 184, 86, 0.10) 0%, rgba(46, 46, 46, 0.10) 37.13%), #1A1A1A;">
            <span class="mr-1 h-2 w-2 rounded-full bg-success-green"></span>
            {numBoosters}
            {t("boosters_online")}
          </span>
          <a
            class="!px-3 !py-[10px] !text-sm font-medium tracking-widest !text-medium-gray transition duration-300 hover:!text-theme-white active:font-medium active:text-black lg:hidden lg:text-slate-100 lg:hover:text-white active:lg:text-white"
            href={localizeUrl("/jobs/")}>{t("navigation.jobs")}</a>
          <a
            class="!px-3 !py-[10px] !text-sm font-medium tracking-widest !text-medium-gray transition duration-300 hover:!text-theme-white active:font-medium active:text-black lg:hidden lg:text-slate-100 lg:hover:text-white active:lg:text-white"
            href={localizeUrl("/blog/")}>{t("navigation.blog")}</a>
          <div class="  mt-4 lg:hidden">
            {#if $user}
              <ProfileMenuContent />
            {:else}
              <Button
                onclick={handleShowLogin}
                id="avatar-menu"
                variant="secondary"
                class="w-full">
                {#if $isUserLoading}
                  <div
                    class="h-4 w-4 animate-spin rounded-full border-b-2 border-white">
                  </div>
                {:else}
                  {t("actions.login")}
                {/if}
              </Button>
            {/if}
          </div>
        </ul>
      {/key}
    </div>

    <div class="flex items-center gap-2">
      <a
        target="_blank"
        class="hidden rounded-[8px] border border-dark-gray bg-light-black !px-4 !py-[10px] !text-sm font-medium tracking-widest !text-theme-white transition duration-300 active:font-medium active:text-black lg:inline"
        href="https://discordapp.com/invite/aMe2WfP"
        >{t("actions.join_discord")}</a>
      <LanguageSelector />
      <span class="hidden lg:inline-block">
        {#if $user}
          <ProfileMenuDropdown />
        {:else}
          <Button
            onclick={handleShowLogin}
            class="px-4 py-[10px]"
            id="avatar-menu"
            variant="accent">
            {#if $isUserLoading}
              <div
                class="h-4 w-4 animate-spin rounded-full border-b-2 border-white">
              </div>
            {:else}
              {t("actions.login")}
            {/if}
          </Button>
        {/if}
      </span>
      <span class="inline-block lg:hidden">
        <Button
          variant="secondary"
          class="p-[10px]"
          onclick={() => {
            bind: showMobileMenu = !showMobileMenu;
          }}
          ><Image
            src={showMobileMenu ? CloseIcon : MenuIcon}
            alt="menu"
            class="h-5 w-5" /></Button>
      </span>
      <span use:createPortal={"cart-button"}> </span>
    </div>
  </div>
  {#if showSecondNavbar}
    <SpecificNavbar game={currentGame} />
  {/if}
</div>
<LoginDialog
  bind:open={showLoginDialog}
  onOpenChange={() => (showLoginDialog = !showLoginDialog)} />
